import { render, staticRenderFns } from "./Dialogs.vue?vue&type=template&id=71c36bc4&scoped=true"
import script from "./Dialogs.vue?vue&type=script&lang=js"
export * from "./Dialogs.vue?vue&type=script&lang=js"
import style0 from "./Dialogs.vue?vue&type=style&index=0&id=71c36bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c36bc4",
  null
  
)

export default component.exports